/**
 * Swaps the displayed cabinet pick-up lead time when the variant changes.
 *
 * Lead time follows the door finish (Option 1), so it is the one piece of
 * variant-dependent text on a cabinet page. Every other metafield this theme
 * renders is product-level and static, so there was no existing pattern to
 * follow -- this is the theme's only client-side variant-driven text swap.
 *
 * Horizon re-renders parts of the product section server-side on variant
 * change, so depending on where the snippet sits this may be redundant. It is
 * written to be harmless in that case: a server-rendered value is already
 * correct, and this either agrees with it or is overwritten by it.
 */
(function () {
  var ROOT_SELECTOR = '[data-cabinet-lead-time]';

  function applyTo(root, variantId) {
    var valueEl = root.querySelector('[data-lead-time-value]');
    var mapEl = root.querySelector('[data-lead-time-map]');
    if (!valueEl || !mapEl) return;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      // Leave whatever was rendered server-side in place. It is at worst the
      // previous finish's lead time, which is no worse than what a hidden
      // element would say, and the server value is usually right.
      return;
    }

    var next = map[String(variantId)];

    if (next) {
      valueEl.textContent = next;
      root.hidden = false;
    } else {
      // Unmapped variant: hide rather than leave the previous finish's lead
      // time on screen. A stale pick-up promise is a broken expectation; an
      // absent one is just absent.
      root.hidden = true;
    }
  }

  document.addEventListener('variant:update', function (event) {
    var detail = event.detail || {};

    // events.js documents `detail.variant` in its usage example at the top of
    // the file, but VariantUpdateEvent's constructor actually assigns
    // `detail.resource`. The example is stale. Read resource first and fall
    // back to variant so this keeps working if that example is ever made true.
    var variant = detail.resource || detail.variant;
    if (!variant || !variant.id) return;

    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      applyTo(roots[i], variant.id);
    }
  });
})();
